import { useSessionKey } from "@auth/sessionStore";
import { EmptyNote, SkeletonStack } from "@scribenote/brian-design-system";
import { useOpenTasks, useTaskCounts } from "@tasks/tasksQueries";
import { openTodoCount } from "@todos/openTodos";
import { TodoRow } from "@todos/TodoRow";

const BAND =
  "flex min-h-0 flex-1 flex-col rounded-[4px] border border-rule bg-card px-[30px] pt-6 pb-4 shadow-sheet";

export const useFrontDeskTodos = () => {
  const sessionKey = useSessionKey();
  const { data } = useOpenTasks(sessionKey);
  return data.pages.flatMap((page) => page.tasks);
};

const useTodoCount = (): number => {
  const sessionKey = useSessionKey();
  const { data } = useTaskCounts(sessionKey);
  return openTodoCount(data);
};

const Heading = ({ count }: { count?: number }) => (
  <div className="flex shrink-0 items-baseline justify-between border-b-[1.5px] border-ink pb-3">
    <h2 className="font-display text-[1.625rem] font-medium tracking-[-0.01em] text-ink">
      To-dos
    </h2>
    {count !== undefined && (
      <span className="font-mono text-[0.8125rem] tracking-[0.04em] text-annotation">
        {count}
      </span>
    )}
  </div>
);

export const TodosBand = () => {
  const todos = useFrontDeskTodos();
  const count = useTodoCount();

  return (
    <section aria-label="To-dos" className={BAND}>
      <Heading count={count} />
      {todos.length === 0 ? (
        <EmptyNote>Nothing open.</EmptyNote>
      ) : (
        <ul className="-mx-2.5 flex min-h-0 flex-1 flex-col gap-1 overflow-y-auto px-2.5 pt-[18px]">
          {todos.map((task) => (
            <TodoRow key={task.id} task={task} />
          ))}
        </ul>
      )}
    </section>
  );
};

export const TodosBandSkeleton = () => (
  <div aria-busy="true" className={BAND}>
    <Heading />
    <SkeletonStack count={3} className="pt-[18px]" itemClassName="h-12" />
  </div>
);
